const Deleteicon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25px"
      height="25px"
      viewBox="0 0 496.268 496.268"
    >
      <g>
        <path
          d="M106.908,64.516V478.11c0,10.024,8.122,18.157,18.158,18.157h246.139c10.036,0,18.158-8.133,18.158-18.157l-0.438-413.594
		H106.908z M168.439,465.627h-27.237V88.851h27.237V465.627z M261.75,465.627h-27.24V88.851h27.24V465.627z M358.592,465.627
		h-27.237V88.851h27.237V465.627z M405.931,18.055v28.259H90.337V18.055h96.284V0H309.65v18.055H405.931z"
        />
      </g>
    </svg>
  );
};

export default Deleteicon;
